import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useSessionStore } from "@/stores/sessionStore";
import AddEditSessionModal from "./AddEditSessionModal";
import { Session } from "@/stores/sessionStore";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

const ProgrammedSessions: React.FC = () => {
  const { sessions, filters, deleteSession, setFilters, modal, openModal } =
    useSessionStore();

  // Filtered sessions based on filters
  const filteredSessions = sessions.filter((session: Session) => {
    return (
      (filters.status === "all" || session.status === filters.status) &&
      (filters.date === "" || session.date === filters.date) &&
      (filters.search === "" ||
        session.title.toLowerCase().includes(filters.search.toLowerCase()) ||
        session.mentor.toLowerCase().includes(filters.search.toLowerCase()))
    );
  });

  return (
    <div className="p-4 sm:p-6 space-y-4 sm:space-y-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
          Sessions Programmés
        </h1>

        <Button
          className="w-full sm:w-auto bg-[#0286BD] h-[40px] sm:h-[55px] text-white font-medium px-4 rounded-[18px] py-[10px]
            transition-all duration-300 transform hover:scale-105 hover:shadow-lg 
            hover:bg-blue-200 hover:text-gray-700 items-center gap-2"
          onClick={() => openModal("add", null)}
        >
          <div className="flex items-center justify-center h-6 w-6 rounded-full bg-blue-300">
            <Plus size={14} className="text-white" />
          </div>
          <span>Ajouter une Session</span>
        </Button>
      </div>

      <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
        <select
          className="p-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 text-sm sm:text-base"
          value={filters.status}
          onChange={(e) => setFilters({ status: e.target.value })}
        >
          <option value="all">All Status</option>
          <option value="Upcoming">Upcoming</option>
          <option value="Completed">Completed</option>
        </select>
        <input
          type="date"
          className="p-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 text-sm sm:text-base"
          value={filters.date}
          onChange={(e) => setFilters({ date: e.target.value })}
        />
        <input
          type="text"
          placeholder="Search by mentor or title"
          className="p-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 text-sm sm:text-base"
          value={filters.search}
          onChange={(e) => setFilters({ search: e.target.value })}
        />
      </div>

      {filteredSessions.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          No sessions found matching your criteria
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {filteredSessions.map((session) => (
            <div
              key={session.id}
              className="p-3 sm:p-4 border border-gray-300 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
            >
              <h3 className="text-base sm:text-lg font-semibold text-gray-700">
                {session.title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-500 mt-1">
                <strong>Date:</strong> {session.date}
              </p>
              <p className="text-xs sm:text-sm text-gray-500">
                <strong>Time:</strong> {session.time}
              </p>
              <p className="text-xs sm:text-sm text-gray-500">
                <strong>Mentor:</strong> {session.mentor}
              </p>
              <p className="text-xs sm:text-sm text-gray-500">
                <strong>Status:</strong>{" "}
                <span
                  className={`${
                    session.status === "Upcoming"
                      ? "text-green-600"
                      : "text-gray-600"
                  }`}
                >
                  {session.status}
                </span>
              </p>
              <div className="flex gap-2 sm:gap-4 mt-3 sm:mt-4">
                <button
                  className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1 text-xs sm:text-sm text-white bg-yellow-500 rounded-lg hover:bg-yellow-600"
                  onClick={() => openModal("edit", session)}
                >
                  <FaEdit size={12} />
                  Edit
                </button>
                <button
                  className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1 text-xs sm:text-sm text-white bg-red-500 rounded-lg hover:bg-red-600"
                  onClick={() => deleteSession(session.id)}
                >
                  <FaTrash size={12} />
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Add/Edit Session Modal */}
      {modal.isOpen && <AddEditSessionModal />}
    </div>
  );
};

export default ProgrammedSessions;
